import React from "react"
import { Link } from "react-router-dom"
import { RootState } from "redux/store"
import { invalidateAll } from "util/helper"
import useAppState from "../hooksV1/useAppState"
import { useDispatch, useSelector } from "react-redux"
import { checkEnvironment } from "../util/environment"
import { makeStyles, Theme } from "@material-ui/core/styles"

const useStyles = makeStyles((theme: Theme) => ({
  homeNavButton: {
    color: "#111B43",
    marginRight: "0.75rem",
    padding: "0.75rem",
    borderRadius: 22,
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
  },
  environmentNavButton: {
    width: 175,
    color: "white",
    borderRadius: 22,
    overflow: "hidden",
    marginRight: "10px",
    textAlign: "center",
    padding: theme.spacing(1.5, 0.5, 1.5, 0.5),
    "&:hover": {
      backgroundColor: "#87a9ce",
    },
  },
  templateEnvironment: {
    background: "#E8EBED",
    color: "#111B43",
  },
  projectEnvironment: {
    background: "#E8EBED",
    color: "#111B43",
  },
}))

const EnvironmentSelector: React.FC = () => {
  const classes = useStyles()
  const appState = useAppState()
  const dispatch = useDispatch()
  const { isProjectEnvironment, isTemplateEnvironment, isHome } =
    checkEnvironment()
  const user = useSelector((state: RootState) => state.authorisation.user)

  const handleEnvironmentChange = () => {
    invalidateAll(dispatch)
    appState.setDocuments([])
    appState.setCountries([])
    appState.setChapterObjects([])
    appState.setChapterObjectsList([])
    appState.setActiveCountry(null)
    appState.setActiveDocument(null)
    appState.setActiveChapterObject(null)
    appState.setActiveDocumentVersion(null)
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {user?.role_id.role_name === "Administrator" && (
        <Link to="/template" onClick={handleEnvironmentChange}>
          <div
            className={
              isHome ? classes.homeNavButton : classes.environmentNavButton
            }
            style={
              isTemplateEnvironment
                ? {
                    background: "#E8EBED",
                    color: "#111B43",
                  }
                : {}
            }
          >
            Template Environment
          </div>
        </Link>
      )}
      <Link to="/project" onClick={handleEnvironmentChange}>
        <div
          className={
            isHome ? classes.homeNavButton : classes.environmentNavButton
          }
          style={
            isProjectEnvironment
              ? {
                  background: "#E8EBED",
                  color: "#111B43",
                }
              : {}
          }
        >
          Project Environment
        </div>
      </Link>
    </div>
  )
}

export default EnvironmentSelector
